<template>
    <div class="detail" v-if="projectDict && data">
        <div class="main-imgs">
            <div class="box">
                <el-image :src="data.pictureUrl[0]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
            <div class="box">
                <el-image :src="data.pictureUrl[1]"  :preview-src-list="data.pictureUrl"></el-image>
                <el-image  :src="data.pictureUrl[2]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
            <div class="box">
                <el-image  :src="data.pictureUrl[3]"  :preview-src-list="data.pictureUrl"></el-image>
                <el-image  :src="data.pictureUrl[4]"  :preview-src-list="data.pictureUrl"></el-image>
            </div>
        </div>
        <div class="content">
            <span>项目编码：{{ data.projectCode }}</span>
            <span>类别：{{ data.projectCategoryName }}</span>
            <span>地区：{{ data.cityName + data.countyName  }}</span>
            <span>起拍价：{{ data.biddingPrice }}万元</span>
            <span>加价幅度：{{ data.biddingUp }}元</span></br>
            <span>报名截止时间：{{ data.offTime }}</span>
            <span>开始时间：{{ data.startTime }}</span>
            <span>结束时间：{{ data.actualEndTime }}</span>
            <a-button type="primary" v-if="data.isApply!='3'" :disabled="data.isApply=='0'?false:true" @click="setOrder(data)">{{ data.isApply=='0'?'报名':data.isApply=='1'?'已报名':data.isApply=='2'?'结束':'' }}</a-button>
            <a-button type="primary"  @click="getVideos">查看视频</a-button>
            <a-button type="primary"  @click="getFiles">查看文件</a-button>
        </div>
        <div class="projectDetail">
            <div>地址：{{ data.cityName + data.countyName + data.townName + data.villageName }}</div>
            <div>周边环境：{{ enviromentName.join(',') }}</div>
            <div>出让方：{{ $utils.getVal(projectDict.bg_transferor,data.transferor) }}</div>
            <div>占地面积：{{ data.coverArea }}㎡</div>
            <div>用地面积：{{ data.landArea }}㎡</div>
            <div v-if="data.projectType == '01'">建筑面积：{{ data.buildArea }}㎡</div>
            <div v-if="data.projectType == '01'">结构：{{ $utils.getVal(projectDict.bg_structure,data.structure) }}</div>
            <div v-if="data.projectType == '01'">建筑年份：{{ data.buildYear }}年</div>
            <div>产权证：{{ data.propertyYear=='1'?'有':'无' }}</div>
            <div>测绘：{{ data.mapping=='1'?'已测绘':'未测绘' }}</div>
            <div>评估：{{ data.assess=='1'?'已评估':'未评估' }}</div>
            <div v-if="data.projectType == '01'">经营权证：{{ data.houseAuthority=='1'?'有':'无' }}</div>
            <div>使用年限：{{ data.restYear }}年</div>
            <div>项目状态：{{ $utils.getVal(projectDict.bg_house_state,data.houseState) }}</div>
            <div v-if="data.orgName">推荐机构：{{ data.orgName }}</div>
        </div>    
        <a-modal title="确定报名？" :visible="visible" :confirmLoading="loading"  cancelText="取消" okText="确定"  @ok="handleOk" @cancel="handleCancel">
            <p>起拍价格：{{ currentItem.biddingPrice }}万元 </p>
            <p>收款人：{{ bankInfo.receiver }}</p>
            <p>银行信息：{{ bankInfo.bankInformation }}</p>
            <p>银行账号：{{ bankInfo.bankAccount }}</p>
            <p>竞拍支付(信用)凭证</p>
            <upload ref="upload" :imageUrl="imageUrl" @getFile="getFile"></upload>
        </a-modal>
        <a-modal title="查看文件" :visible="boxVsile" cancelText="取消" okText="确定"  @ok="handleOkbox" @cancel="handleCancelbox">
            <p v-for="(item,index) in fileList" :key="index" style="cursor:pointer" @click="getFiledetail(item.url)">{{ item.name }}</p>
        </a-modal>
         <videoList ref="videoList"></videoList>
    </div>    
</template>
<script>
import upload from '@/components/uploadnomu.vue'
export default {
    components:{
        upload
    },
    data(){
        return{
            data:'',
            projectDict:'',
            enviromentName:[],
            query:{
                biddingId:'',
                applyUrl:'',
            },
            imageUrl:'',
            visible:false,
            loading:false,
            currentItem:'',
            fileList:[],
            bankInfo:'',
            boxVsile:false
        }  
    },
    created(){
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                    this.getBaseInfo(this.$route.query.id)
                }else{
                     this.$message.info(res.msg)
                }
        })
        this.$https.get('/system/bank/bankList').then(res=>{
            if(res.code == 200){
                this.bankInfo = res.rows[0];
            }else{
                this.$message.error('获取失败')
            }
        })
      
    },
    mounted(){
        this.$parent.current = '3';
    },
    methods:{
        handleOkbox(){
            this.boxVsile = false;
        },
        handleCancelbox(){
            this.boxVsile = false;
        },
        getBaseInfo(id){
            this.$https.get(`/portal/bidding/getInfo/${id}`).then(res=>{
                if(res.code == 200){
                    res.data.pictureUrl = res.data.pictureUrl.split(',');
                    res.data.enviroment = res.data.enviroment.split(',');
                    res.data.enviroment.forEach(item=>{
                        this.projectDict.bg_enviroment.forEach(ele=>{
                            if(item == ele.dict_value){
                                this.enviromentName.push(ele.dict_label)
                            }
                        })
                    })
                    this.data = res.data;
                }
            })
        },
        handleOk(){

            if(!this.imageUrl){
               this.$message.info('请上传竞竞拍支付(信用)凭证');
               return false
            }
            this.loading = true;
            this.query.biddingId = this.currentItem.id;
            this.query.applyUrl = this.imageUrl;
            this.$https.post('/portal/bidding/projectBiddingApply',this.query).then(res=>{
                this.loading =false;
                if(res.code == 200){
                    this.$message.success('报名成功');
                    this.visible = false;
                }else{
                    this.$message.info(res.msg)
                }
            }).catch(error=>{
                this.$message.info(error.msg)
                this.loading = false;
            })
        },
        handleCancel(){
            this.visible = false;
        },
        setOrder(item){
            this.currentItem = item;
            this.visible = true;
        },
        getFile(info){
           this.imageUrl = info.file.response.data.url;

        },
        getVideos(){
            let videoList = [];
                videoList = this.data.videoUrl?this.data.videoUrl.split(','):[];
                console.log(this.data)
            if(videoList.length == 0){
                this.$message.info('没有发现视频喔')
            }else{
                this.$refs.videoList.showDialog(videoList)
            }
        },
        getFiles(){
            this.fileList = JSON.parse(this.data.fileUrl);
            if(this.fileList.length>0){
                this.boxVsile = true;
            }else{
                this.$message.info('没有查到文件喔')
            }
        },
        getFiledetail(url){
            window.open(url)
        }
    }
}
</script>

<style lang="less" scoped>
.detail{
      width: 1300px;
      margin: 0 auto;
      .main-imgs{
          display: flex;
          .box{
                border:5px solid #fff;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                &:nth-of-type(1){
                    width: 770px;
                    height: 440px;
                    margin-right:5px;
                    background: coral;
                    .el-image{
                            &:hover{
                                transform:scale(1.2,1.2);
                                transition:All 0.4s ease-in-out;
                                -webkit-transition:All 0.4s ease-in-out;
                                -moz-transition:All 0.4s ease-in-out;
                                -o-transition:All 0.4s ease-in-out;
                            }
                        }
                }
                &:nth-of-type(2){
                    width: 260px;
                    height: 440px;
                    margin-right:5px;
                    background:darkgray;
                    flex-direction: column;
                        .el-image{
                            height: 215px;
                            width: 260px;
                            &:hover{
                                transform:scale(1.2,1.2);
                                transition:All 0.4s ease-in-out;
                                -webkit-transition:All 0.4s ease-in-out;
                                -moz-transition:All 0.4s ease-in-out;
                                -o-transition:All 0.4s ease-in-out;
                            }
                        }
                }
                &:nth-of-type(3){
                    width: 260px;
                    height: 440px;
                    background:darkorange;
                    flex-direction: column;
                       .el-image{
                            height: 215px;
                            width: 260px;
                               &:hover{
                                    transform:scale(1.2,1.2);
                                    transition:All 0.4s ease-in-out;
                                    -webkit-transition:All 0.4s ease-in-out;
                                    -moz-transition:All 0.4s ease-in-out;
                                    -o-transition:All 0.4s ease-in-out;
                                }
                        }
                }
          }
      }
      .content{
         background: white;
         line-height: 40px;
         padding: 20px 10px;
         margin-top:10px;
         span{
             margin-right:70px;
         }
         .ant-btn{
             float: right;
             margin-top:9px;
             margin-left:20px;
         }
      }
      .contentfile{
         background: white;
         line-height: 20px;
         padding: 10px 10px;
         margin-top:10px;
      }
      .projectDetail{
          display: flex;
          flex-wrap:wrap;
          background: white;
          margin:20px 0;
          padding: 10px;
          div{
              width: 25%;
              line-height: 30px;
          }
      }
}
</style>